<template>
  <div
    class="h2-template-board"
    :class="{ 'h2-template-board-results': mostrarResultados }"
  >
    <div class="diagram-wrapper-3d">
      <VueFlow
        :nodes="diagram.nodes"
        :edges="diagram.edges"
        :node-types="nodeTypes"
        :fit-view-options="fitViewOptions"
        :min-zoom="mostrarResultados ? 0.55 : 0.90"
        :max-zoom="mostrarResultados ? 1.2 : 0.90"
        :zoom-on-scroll="mostrarResultados"
        :zoom-on-pinch="mostrarResultados"
        :zoom-on-double-click="mostrarResultados"
        :pan-on-drag="mostrarResultados"
        :pan-on-scroll="false"
        :nodes-draggable="false"
        :nodes-connectable="false"
        :elements-selectable="false"
        fit-view
        class="flow-3d"
        @node-click="onNodeClick"
      >
        <Background variant="dots" :gap="22" :size="1" />
      </VueFlow>
    </div>
  </div>
</template>
<script>
import { VueFlow } from '@vue-flow/core'
import { Background } from '@vue-flow/background'
import ComponenteNodo from './ComponenteNodo.vue'

export default {
  name: 'DiagramaVueFlow',

  components: {
    VueFlow,
    Background
  },

  props: {
    diagram: {
      type: Object,
      required: true,
      validator: value =>
        Array.isArray(value.nodes) && Array.isArray(value.edges)
    },

    mostrarResultados: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      nodeTypes: {
        custom: ComponenteNodo
      },

      fitViewOptions: {
        padding: 0.04,
        includeHiddenNodes: false,
        minZoom: 0.7,
        maxZoom: 0.9
      }
    }
  },
  methods: {
    onNodeClick({ node }) {
      const destino = node?.data?.moduleTarget

      if (!destino) return

      this.$emit('module-click', destino)
    }
  }

  /*computed: {
    cellNodes() {
      return this.diagram.nodes.filter(
        n => n.type === 'custom' && n.data?.templateCell
      )
    },

    totalCells() {
      return this.cellNodes.length
    },

    usedCells() {
      return this.cellNodes.filter(n => !n.data?.emptyCell).length
    },

    capacityPercent() {
      if (!this.totalCells) return 0
      return Math.round((this.usedCells / this.totalCells) * 100)
    },

    hasResults() {
      return this.diagram.nodes.some(
        n => n.data?.resultsCard || n.data?.showResult
      )
    }
  }*/
}
</script>

<style scoped>
.h2-template-board {
  position: relative;
  width: 100%;
  max-width: 660px;
  height: auto;
  margin: 40px auto 16px auto;
  padding: 12px;
  border-radius: 16px;
  border: 2px solid #dbe9e7;
  background:
    linear-gradient(135deg, #f8fbfb 0%, #eef7f6 45%, #ffffff 100%);
  box-shadow:
    0 6px 18px rgba(49, 99, 95, 0.10),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);
  overflow: visible;
}

.h2-template-board::before {
  content: "";
  position: absolute;
  inset: auto -20px -45px -20px;
  height: 130px;
  background:
    radial-gradient(circle at 20% 50%, rgba(49, 99, 95, 0.12), transparent 32%),
    radial-gradient(circle at 75% 45%, rgba(49, 99, 95, 0.10), transparent 35%);
  pointer-events: none;
}

/* CABECERA SUPERIOR 

.h2-template-header {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: 86px 1fr;
  gap: 12px;
  align-items: center;
  margin-bottom: 12px;
  padding: 10px;
  border-radius: 18px;
  border: 1px solid rgba(49, 99, 95, 0.18);
  background:
    linear-gradient(135deg, rgba(255,255,255,0.97), rgba(239,248,247,0.94)),
    linear-gradient(90deg, rgba(126,231,135,0.10), rgba(85,167,255,0.10));
  box-shadow:
    0 8px 20px rgba(49, 99, 95, 0.10),
    inset 0 1px 0 rgba(255,255,255,0.95);
}

.h2-header-icon {
  position: relative;
  width: 74px;
  height: 74px;
  min-width: 74px;
  border-radius: 18px;
  background: linear-gradient(135deg, #ffffff, #eef7f6);
  border: 1px solid rgba(49, 99, 95, 0.18);
  box-shadow:
    0 6px 14px rgba(49, 99, 95, 0.14),
    inset 0 1px 0 rgba(255,255,255,0.85);
  display: flex;
  align-items: center;
  justify-content: center;

  /* Importante: permite que la imagen salga del cuadrado 
  overflow: visible;
}

/* Halo detrás de la imagen 
.h2-header-icon::before {
  content: "";
  position: absolute;
  width: 86px;
  height: 86px;
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgba(114, 255, 221, 0.55) 0%,
    rgba(114, 255, 221, 0.28) 42%,
    rgba(114, 255, 221, 0.08) 68%,
    transparent 78%
  );
  box-shadow:
    0 0 12px rgba(114, 255, 221, 0.55),
    0 0 26px rgba(114, 255, 221, 0.35);
  z-index: 0;
  pointer-events: none;
}

.h2-header-image {
  position: relative;
  z-index: 1;

  /* Más grande que el cuadrado 
  width: 95px;
  height: 95px;
  object-fit: contain;
  display: block;

  filter:
    drop-shadow(0 0 8px rgba(114, 255, 221, 0.75))
    drop-shadow(0 0 18px rgba(114, 255, 221, 0.45))
    drop-shadow(0 5px 6px rgba(0, 0, 0, 0.20));
}

.h2-header-icon .material-symbols-outlined {
  font-size: 42px;
  color: #31635f;
  filter: drop-shadow(0 3px 4px rgba(49, 99, 95, 0.18));
}

.h2-header-content {
  min-width: 0;
   overflow: visible;
  
}

.h2-header-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.h2-template-title {
  display: inline-flex;
  align-items: center;
  font-family: "Orbitron", sans-serif !important;
  color: #244946;
  font-size: 17px;
  font-weight: 900;
  letter-spacing: 0.7px;
  text-transform: uppercase;
  text-shadow: 0 1px 0 rgba(255,255,255,0.9);
}

.h2-header-bars {
  display: flex;
  align-items: flex-end;
  gap: 5px;
  height: 28px;
  padding: 4px 6px;
  border-radius: 10px;
  background: rgba(255,255,255,0.75);
  border: 1px solid rgba(49, 99, 95, 0.12);
}

.h2-header-bars span {
  display: block;
  width: 9px;
  border-radius: 4px 4px 2px 2px;
  background: linear-gradient(180deg, #7ee787, #3dd6b3 55%, #55a7ff);
  box-shadow: 0 0 8px rgba(61, 214, 179, 0.55);
}

.h2-header-bars span:nth-child(1) {
  height: 13px;
  opacity: 0.55;
}

.h2-header-bars span:nth-child(2) {
  height: 21px;
  opacity: 0.85;
}

.h2-header-bars span:nth-child(3) {
  height: 26px;
}

.h2-status-panel {
  position: relative;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 4px 10px;
  align-items: center;
  overflow: visible;
}

.h2-energy-track {
  position: relative;
  grid-column: 1 / -1;
  height: 18px;
  border-radius: 999px;
  overflow: visible;
  background: transparent;
}

/* Fondo real de la barra 
.h2-energy-track::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 999px;
  background: linear-gradient(180deg, #f5f8f8, #e2eceb);
  border: 1px solid rgba(49, 99, 95, 0.16);
  box-shadow:
    inset 0 2px 5px rgba(49, 99, 95, 0.12);
  z-index: 0;
}

/* Relleno interior 
.h2-energy-progress {
  position: absolute;
  inset: 0 auto 0 0;
  border-radius: 999px;
  background:
    linear-gradient(
      90deg,
      rgba(126,231,135,0.55),
      rgba(61,214,179,0.45),
      rgba(85,167,255,0.50)
    );
  box-shadow:
    0 0 14px rgba(61,214,179,0.45),
    inset 0 1px 0 rgba(255,255,255,0.65);
  transition: width 0.35s ease;
  z-index: 1;
}

/* Ondas saliendo fuera de la barra 
.h2-energy-wave {
  position: absolute;
  left: 0;
  top: -26px;
  height: 70px;
  overflow: visible;
  pointer-events: none;
  transition: width 0.35s ease;
  z-index: 3;
}

.h2-energy-wave svg {
  width: 100%;
  height: 100%;
  display: block;
  overflow: visible;
  filter:
    drop-shadow(0 0 5px rgba(61,214,179,0.70))
    drop-shadow(0 0 12px rgba(85,167,255,0.45));
}

.h2-status-text {
  position: relative;
  z-index: 2;
  grid-column: 1;
  font-family: "Orbitron", sans-serif !important;
  color: #244946;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.35px;
  text-transform: uppercase;
  white-space: nowrap;
}

.h2-online-pill {
  position: relative;
  z-index: 2;
  grid-column: 2;
  justify-self: end;
  width: fit-content;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: "Orbitron", sans-serif !important;
  font-size: 9px;
  font-weight: 800;
  color: #217a4b;
  text-transform: uppercase;
  padding: 4px 8px;
  border-radius: 999px;
  background: rgba(126, 231, 135, 0.20);
  border: 1px solid rgba(33, 122, 75, 0.18);
  box-shadow: 0 0 10px rgba(126,231,135,0.28);
}
*/
/* DIAGRAMA */

.diagram-wrapper-3d {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 770px;
  border-radius: 14px;
  overflow: auto;
  background:
    linear-gradient(180deg, rgba(255,255,255,0.80), rgba(245,250,250,0.55)),
    linear-gradient(145deg, #fbffff, #eef7f7);
  box-shadow:
    inset 0 0 28px rgba(0, 0, 0, 0.05);
}

/* Antes estaba en width/height 100% */
.flow-3d {
  width: 760px;
  height: 900px;
  min-width: 760px;
  min-height: 900px;
}

/* VUE FLOW */

:deep(.vue-flow__node.selected) {
  box-shadow: none !important;
}

:deep(.vue-flow__handle) {
  width: 10px !important;
  height: 10px !important;
  opacity: 0 !important;
  border: none !important;
  background: transparent !important;
  pointer-events: none !important;
}

:deep(.vue-flow__node-default) {
  font-family: "Orbitron", sans-serif !important;
  color: #244946;
  font-size: 14px;
  font-weight: 800;
  border-radius: 14px !important;
  border: 1px solid rgba(49, 99, 95, 0.20) !important;
  box-shadow:
    0 5px 12px rgba(49, 99, 95, 0.08),
    inset 0 1px 0 rgba(255,255,255,0.75);
}

/* RESPONSIVE */

@media (max-width: 700px) {
  .h2-template-board {
    max-width: 100%;
    height: auto;
  }

  .h2-template-header {
    grid-template-columns: 1fr;
  }

  .h2-header-icon {
    display: none;
  }

  .h2-header-top {
    align-items: flex-start;
  }

  .h2-template-title {
    font-size: 14px;
  }

  

  .h2-status-text {
    white-space: normal;
    line-height: 1.4;
  }

  .h2-online-pill {
    width: fit-content;
  }

  .diagram-wrapper-3d {
    height: 760px;
  }
}

/* MODO RESULTADOS */

.h2-template-board-results {
  max-width: 1450px;
  width: min(1450px, calc(100vw - 260px));
  height: calc(100vh - 140px);
  max-height: calc(100vh - 140px);
  overflow-y: auto;
  overflow-x: auto;
  margin: 40px auto 260px auto;
}

.h2-template-board-results .diagram-wrapper-3d {
  height: 1450px;
  min-height: 1450px;
  overflow: visible;
}
.h2-template-board-results .flow-3d {
  width: 1450px;
  min-width: 1450px;
  height: 1450px;
  min-height: 1450px;
}
</style>